import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UrlService } from '@core/services/url/url.service';
import { FileMetadata } from '@core/objects/storage';
import { StorageFileSizePipe } from '@core/pipes/storage-file-size.pipes';

/**
 * Component to display a file that has been uploaded, with options to remove or download the file.
 * It displays the file name, size, and extension, and can show a download icon if the download option is enabled.
 * no 'Download' or other word text is shown based on actionText of the list item, only the icon.
 */
@Component({
    selector: 'core-storage-file-uploaded-list-item',
    templateUrl: './storage-file-uploaded-list-item.component.html',
    styleUrls: ['./storage-file-uploaded-list-item.component.scss']
})
export class CoreStorageFileUploadedListItemComponent implements OnInit {

    @Input() file: FileMetadata;
    @Input() remove: boolean = false;
    @Input() download: boolean = false;

    @Output() onRemove = new EventEmitter<any>();
    @Output() onSelect = new EventEmitter<any>();

    public downloadIcon: string = "";
    public mainText: string = "";


    constructor(public urlService: UrlService) { }

    ngOnInit() {

        const pipe = new StorageFileSizePipe();
        //console.log("file list item: ",this.file);
        this.mainText = "<span class=\"name\">" + this.file.name + `</span> <span class=\"file-size\">(${pipe.transform(this.file.size)})  </span>`;

        if(this.download)
            this.downloadIcon = "download";
    }

    onMainAction(event: any) {

        if (this.download){
            this.downloadAction();
            return false;
        }
        this.onSelect.emit(this.file);
    }

    downloadAction() {
        if(!this.download)
            return false;
        let downloadURI = '';

        if(this.file.uuid){
            downloadURI = this.urlService.buildFiles('/app/f/' + this.file.uuid);
        }
        if(this.file.id){ // keep legacy ids for download.
            downloadURI = this.urlService.build('/files/' + this.file.id);
        }

        // Create a temporary link element to trigger the download
        if (downloadURI != '') {
            const link = document.createElement('a');
            link.href = downloadURI;

            // Set attribute 'download' to suggest downloading instead of navigating 
            link.setAttribute('download', '');

            // Append the link to the body and trigger a click to start the download
            document.body.appendChild(link);
            link.click();

            // Clean up by removing the link from the document
            document.body.removeChild(link);
        }
    }

    getFileExtension(name: string ): string {
        const cleanName = name.split(' ').pop() || name;
        const parts = cleanName.split('.');
        return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
    }

}
